import api from '../config/api';
import { isApiEnabled } from '../config/appConfig';
import { getApiData, parseApiError } from './apiUtils';
import { defaultLanguage } from '../constants/languages';

const LANGUAGE_KEY = 'blf_language';

export const getStoredLanguage = () => {
  try {
    return window.localStorage.getItem(LANGUAGE_KEY) || defaultLanguage;
  } catch (error) {
    return defaultLanguage;
  }
};

export const saveStoredLanguage = (code) => {
  try {
    window.localStorage.setItem(LANGUAGE_KEY, code);
  } catch (error) {
    // Ignorar errores de almacenamiento.
  }
};

export const saveUserLanguage = (usuarioId, idioma) => {
  if (!usuarioId) {
    return Promise.reject(new Error('Debes iniciar sesión para guardar tu idioma.'));
  }

  if (!idioma) {
    return Promise.reject(new Error('Selecciona un idioma válido.'));
  }

  saveStoredLanguage(idioma);

  if (!isApiEnabled()) {
    return Promise.resolve({ idioma });
  }

  return api
    .post('/perfil_idioma_guardar.php', {
      usuario_id: usuarioId,
      idioma,
    })
    .then((response) => getApiData(response, 'No se pudo guardar el idioma.'))
    .catch((error) => {
      throw parseApiError(error);
    });
};

export const resolveUserLanguage = (user) => {
  if (user && user.idioma) {
    return user.idioma;
  }

  return getStoredLanguage();
};
